import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { COOP_GEN } from "./coop_gen";

export function coopSlug(lang) {
  return (COOP_GEN[lang] || COOP_GEN[DEFAULT_LANG] || {}).slug;
}
export function coopData(lang) {
  return COOP_GEN[lang] || COOP_GEN[DEFAULT_LANG] || {};
}
export function coopPath(lang) {
  return `${langPrefix(lang)}/${coopSlug(lang)}`;
}
export function buildCoopAlternates(origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => coopSlug(l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${coopPath(l.code)}` }));
  if (coopSlug(DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${coopPath(DEFAULT_LANG)}` });
  return alts;
}
export const COOP_SLUGS = Object.fromEntries(LOCALES.map((l) => [l.code, coopSlug(l.code)]).filter(([, s]) => s));
